"use strict";
function appendFlattenedValue(formData, value, keyPath) {
  if (value instanceof File || value instanceof Blob) {
    formData.append(keyPath, value);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item) => {
      appendFlattenedValue(formData, item, `${keyPath}[]`);
    });
    return;
  }
  if (value !== null && typeof value === "object") {
    Object.keys(value).forEach((key) => {
      const nextKey = keyPath ? `${keyPath}[${key}]` : key;
      appendFlattenedValue(formData, value[key], nextKey);
    });
    return;
  }
  if (value !== void 0 && value !== null) {
    formData.append(keyPath, value);
  }
}
function filesFromHiFile(hiFile) {
  return Array.from(hiFile.files || []).filter((file) => file instanceof File);
}
export default class InquiryFormDocumentUploads {
  visibleDocumentFileInputs() {
    return Array.from(document.querySelectorAll('hi-file[data-node-type="document"]')).filter((fileInput) => !fileInput.closest(".hide") && fileInput.getAttribute("name"));
  }
  collectDocumentFilesFromDom() {
    return this.visibleDocumentFileInputs().flatMap((fileInput) => {
      const name = fileInput.getAttribute("name");
      return filesFromHiFile(fileInput).map((file) => [name, file]);
    });
  }
  // hi-form never fails submission on file controls, so missing, oversized and
  // wrong-type files reach the server unless we check hi-file's validity ourselves.
  // validate() both reports validity and renders hi-file's own message.
  hasInvalidDocuments() {
    const invalidInputs = this.visibleDocumentFileInputs().filter((fileInput) => !fileInput.validate());
    if (invalidInputs.length === 0) return false;
    invalidInputs[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
    return true;
  }
  buildSubmitPayload(formValues) {
    const documentFiles = this.collectDocumentFilesFromDom();
    if (documentFiles.length === 0) {
      return { body: JSON.stringify(formValues), isMultipart: false };
    }
    const formData = new FormData();
    appendFlattenedValue(formData, formValues, "");
    documentFiles.forEach(([name, file]) => formData.append(name, file));
    return { body: formData, isMultipart: true };
  }
}
